import config from './config';

export const themeOverride = config.theme;
